// Distances in artwork units (353x107); per-blob reaction is in aiAssistantAuraBlobs.js
const aiAssistantAuraConfig = {
    // Orbit, a shared ellipse: seconds per cycle, speed gain at full level, radii, scale swing
    BASE_CYCLE_S: 6,
    SPEED_GAIN: 3,
    ORBIT_X: 12,
    ORBIT_Y: 8,
    ORBIT_SCALE: 0.1,
    // Share of the orbit travelled at silence (an idle aura still moves) + what full level adds
    REST_AMPLITUDE: 0.55,
    LEVEL_AMPLITUDE: 0.9,

    // Wander: non-repeating per-blob noise, WANDER_WAVES random sines within this band
    WANDER_WAVES: 3,
    WANDER_MIN_HZ: 0.05,
    WANDER_MAX_HZ: 0.23,
    // Wander strength on position, scale and opacity
    WANDER_X: 14,
    WANDER_Y: 9,
    WANDER_SCALE: 0.05,
    WANDER_OPACITY: 0.06,
    // Wander on the orbit speed. Keep below 1, or the orbit can run backwards
    WANDER_PACE: 0.35,

    // Well below 1, so additive blending has room to brighten
    REST_OPACITY: 0.55,

    // Aura height scale at rest + extra at full level; scales from the bottom, so no gap opens below
    FIELD_REST_SCALE_Y: 1.25,
    FIELD_LEVEL_SCALE_Y: 0.35,
};

export default aiAssistantAuraConfig;
